@import '../../../global/styles/focus.scss';

:host {
    --arv-blue: #0076b2;

    main {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 11000;
        background-color: rgba(0, 0, 0, 0.5);
    }

    main.hide {
        display: none;
    }

    .background {
        background-color: white;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
    }

    .content {
        display: flex;
        padding: 20px;
        justify-content: space-between;
        align-items: center;
        max-width: 1440px;
        margin-left: auto;
        margin-right: auto;

        .close {
            cursor: pointer;
        }
        .close:focus-visible {
            @include on-focus;
        }
    }

    .text {
        text-align: start;
        font-family: arv-open-sans;
        font-size: 16px;
    }

    .group {
        width: auto;
        display: flex;
        justify-content: center;
        align-items: center;
        max-height: 206px;

        .world {
            margin-right: 12px;
        }

        arv-button-animated {
            margin-left: 32px;
        }

        .dropdown {
            --arv-dropdown-width: 240px;
            width: var(--arv-dropdown-width);
            height: 48px;
            cursor: pointer;
            display: flex;
            user-select: none;
            position: relative;
            border: 1px solid black;

            &:focus-visible {
                @include on-focus;
            }

            span {
                padding: 11px 24px;
                font-size: 16px;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-family: arv-open-sans;

                .rotate {
                    transform: rotate(270deg);
                }
            }

            .inner {
                position: absolute;
                background-color: white;
                color: black;
                top: 100%;
                display: flex;
                flex-direction: column;
                gap: 20px;
                padding: 24px;
                z-index: 2;

                overflow: hidden;

                width: calc(var(--arv-dropdown-width) - 48px);
                font-weight: 100;
                font-size: 16px;
                font-weight: 400;
                line-height: 16px;
                opacity: 0;
                color: black;
                border: 1px solid black;
                transform-origin: top;
                transform: translateY(0);
                transition: opacity 300ms ease, transform 600ms ease;
                pointer-events: none;
                visibility: hidden;

                &.open {
                    transform: translateY(16px);
                    opacity: 1;
                    pointer-events: auto;
                    visibility: visible;
                }

                span {
                    padding: 0;
                    width: fit-content;
                    margin-top: 8px;
                    position: relative;
                    display: inline-block;
                    padding-bottom: 3px;

                    &:focus-visible {
                        @include on-focus;
                    }
                }

                span:hover {
                    color: var(--arv-blue);
                }

                span::before {
                    content: '';
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 0;
                    height: 1px;
                    background-color: var(--arv-blue);
                    transition: width 0.3s ease;
                }

                span:hover::before {
                    width: 100%;
                }
            }
        }
    }

    .content {
        @media screen and (max-width: 1006px) {
            display: grid;

            .dropdown {
                --arv-dropdown-width: 155px;
            }

            .group {
                padding-top: 20px;
                justify-content: inherit;
                grid-column: 1 / 3;
            }

            .close,
            .text {
                grid-row: 1;
            }
        }
    }
}
